import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { BRAND } from '../../constants/branding';

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h5" fontWeight={700} gutterBottom sx={{ color: BRAND.colors.text }}>
      {title}
    </Typography>
    <Typography variant="body1" component="div" sx={{ color: BRAND.colors.textDim, lineHeight: 1.9 }}>
      {children}
    </Typography>
  </Box>
);

export const AboutPage: React.FC = () => (
  <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
    <Typography variant="overline" sx={{ color: BRAND.colors.primary, fontWeight: 700, letterSpacing: '0.1em' }}>
      About us
    </Typography>
    <Typography variant="h3" fontWeight={800} sx={{ mt: 1, mb: 3 }}>
      Built for creators who move fast
    </Typography>
    <Typography sx={{ mb: 5, lineHeight: 1.8, color: BRAND.colors.textMuted }}>
      {BRAND.nameUpper} was created to solve a simple problem: social media is essential for growth,
      but creating and publishing great content every day is exhausting. We combine AI-assisted
      writing, multi-platform publishing, and smart scheduling so you can focus on your message —
      not the mechanics.
    </Typography>

    <Section title="Our mission">
      Empower individuals and teams to show up consistently on social media with content that sounds
      like them — without spending hours in tabs, docs, and scheduling tools.
    </Section>

    <Section title="What we believe">
      Great tools should be simple. AI should amplify your voice, not replace it. And publishing
      across LinkedIn, X, and Instagram should feel like one workflow, not three.
    </Section>

    <Section title="Who it's for">
      Founders, marketers, freelancers, and small teams who want a reliable way to plan, generate,
      schedule, and publish social content from a single dashboard at {BRAND.domain}.
    </Section>
  </Container>
);

export default AboutPage;
